import React from 'react';
import { FileIcon, EyeIcon, DownloadIcon } from 'lucide-react';
import { Document } from '../types/documents';
interface DocumentRowProps {
  document: Document;
  onView: (doc: Document) => void;
}
export function DocumentRow({
  document,
  onView
}: DocumentRowProps) {
  return <div className="group flex items-center justify-between py-3 px-6 border-b border-[#DDDBDA] hover:bg-[#F9F9F9] transition-colors duration-200" data-id="element-60">
      <div className="flex items-start space-x-4 flex-1 min-w-0" data-id="element-61">
        <div className="flex-shrink-0 mt-1" data-id="element-62">
          <div className="w-8 h-10 bg-[#E3F2FD] rounded flex items-center justify-center border border-[#0176D3]/20" data-id="element-63">
            <FileIcon className="w-5 h-5 text-[#0176D3]" aria-hidden="true" data-id="element-64" />
          </div>
        </div>
        <div className="flex flex-col min-w-0 flex-1" data-id="element-65">
          <h4 className="text-sm font-semibold text-[#0176D3] truncate group-hover:underline cursor-pointer" onClick={() => onView(document)} data-id="element-66">
            {document.name}
          </h4>
          <div className="flex items-center text-xs text-[#706E6B] mt-1 space-x-2" data-id="element-67">
            <span data-id="element-68">{document.type}</span>
            <span data-id="element-69">&bull;</span>
            <span data-id="element-70">{document.date}</span>
            <span data-id="element-71">&bull;</span>
            <span data-id="element-72">{document.size}</span>
          </div>
        </div>
      </div>

      <div className="flex items-center gap-2 ml-4 flex-shrink-0" data-id="element-73">
        <button className="flex items-center justify-center px-3 py-1.5 text-sm font-medium text-[#444444] bg-white border border-[#DDDBDA] rounded hover:bg-[#F3F3F3] focus:outline-none focus:ring-2 focus:ring-[#0176D3] focus:ring-offset-1 transition-colors" aria-label={`Download ${document.name}`} data-id="element-74">
          <DownloadIcon className="w-4 h-4 mr-1.5" aria-hidden="true" data-id="element-75" />
          Download
        </button>
        <button onClick={() => onView(document)} className="flex items-center justify-center px-3 py-1.5 text-sm font-medium text-[#0176D3] bg-white border border-[#DDDBDA] rounded hover:bg-[#F3F3F3] focus:outline-none focus:ring-2 focus:ring-[#0176D3] focus:ring-offset-1 transition-colors" aria-label={`View ${document.name}`} data-id="element-76">
          <EyeIcon className="w-4 h-4 mr-1.5" aria-hidden="true" data-id="element-77" />
          View
        </button>
      </div>
    </div>;
}